import React, { useState, useEffect, useContext } from "react";
import MUIDataTable from "mui-datatables";
import Grid from "@mui/material/Grid";
import { AiOutlineUserAdd } from "react-icons/ai";
import { styled } from "@mui/material/styles";
import Modal from "@mui/material/Modal";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import { services } from "../services/api";
import Button from "@mui/material/Button";
import { NotificacionContext } from "../context/notificacion_context";
import IconUI from "./ui/icon_ui";
import { Box, Tooltip } from "@mui/material";
import Select from "react-select";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { GlobalContext } from "../context/global_context";
import SearchIcon from "@mui/icons-material/Search";
import LoaderComponent from "./LoaderComponent";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";



const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "95%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  mb: 2,
  display: "flex",
  flexDirection: "column",
  height: 550,
  overflow: "hidden",
  overflowY: "scroll",
};

const smallScreen = window.matchMedia("(max-width: 600px)").matches;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: smallScreen ? "95%" : "70%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  mb: 2,
  display: "flex",
  flexDirection: "column",
  height: "90vh",
  overflow: "hidden",
  overflowY: "scroll",
};

const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#005cbf"),
  backgroundColor: "#4A001F",
  "&:hover": {
    backgroundColor: "#4A001F",
  },
}));

const CustomSearch = ({ searchText, onSearch, onHide, onClear }) => {
    const [value, setValue] = useState(searchText || "");
    useEffect(() => { setValue(searchText || ""); }, [searchText]);
    const handleKeyDown = (e) => { if (e.key === "Enter") onSearch(value); };
    const handleClear = () => {
        setValue("");
        if (onClear) onClear();
        onHide();
    };
    return (
        <div style={{ display: "flex", alignItems: "center", marginRight: "24px" }}>
            <TextField
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Buscar por Alumno"
                variant="standard"
                InputProps={{
                    endAdornment: (
                        <IconButton onClick={() => onSearch(value)}> <SearchIcon /> </IconButton>
                    ),
                }}
            />
            <IconButton onClick={handleClear}> <ClearIcon /> </IconButton>
        </div>
    );
};

const Inscripciones = () => {


  const [state, setState] = useState({
    alumnos: [],
    loadingAlumnos: true,
    loadingTalleres: true,
    open: false,
    openCaptura: false,
    alumnoSelect: null,
    disciplinasSeleccionadas: [],
    TallerSelect: [],
    idTaller: [],
    errorAlumnoS: false,
    errorTallerS: false,
    talleres: [],
    data: [],
    alumnosInscritos: [],
    talleresAlumnosInscritos: [],
    count: 0,
    page: 0, 
    rowsPerPage: 50,
    searchText:'',        
    alumnoActual: "",
    loading: true,
    fecha_inscripcion: "",
    descuento: "",
    tipo_descuento: "",
    talleresOption: [],
    formato: "",
  });

  const [validate, setValidation] = useState({
    alumnoValidate: "gray",
    disciplinaValidate: "gray",
    tallerValidate: "gray",
  });

  const { showNotification } = useContext(NotificacionContext);
  // eslint-disable-next-line
  const { GlobalState, setGlobalState } = useContext(GlobalContext);

  const openmodal = () => {
    setState({ ...state, open: true });
  };

  const [loader, setLoader] = useState(false);

  const handleClose = () => {
    setState({
      ...state,
      open: false,
      openCaptura: false,
      alumnoSelect: null,
      TallerSelect: [],
      disciplinaSelect: [],
      errorAlumnoS: false,
      errorTallerS: false,
      idTaller: [],
      openDetalle: false,
    });
  };

  const openmodalDetalle = (talleres) => {
    setState({
      ...state,
      openDetalle: true,
      talleresAlumnosInscritos: state.alumnosInscritos[talleres].talleres,
      alumnoActual: state.alumnosInscritos[talleres].alumno,
    });
    
  };

  const customSearchFn = (searchText, handleSearch, hideSearch) => {
        return (
            <CustomSearch
                searchText={searchText}
                onSearch={(val) => {
                    handleSearch(val); 
                    obtenerDatos(1, val); 
                }}
                onHide={hideSearch}
                onClear={() => {
                    handleSearch("");
                    obtenerDatos(1, "");
                }}
            />
        );
    };

    const handleTableChange = (action, tableState) => {
        switch (action) {
            case 'changePage':
              
                obtenerDatos(tableState.page + 1, state.searchText);
                break;
            case 'search':
                
                break;
            case 'propsUpdate':
                break;
            default:
               
                break;
        }
    };
  
    

   
   
  const handleCloseDetalle = () => {
    setState({ ...state, openDetalle: false });
  };


  const columns = [
    {
      name: "alumno",
      label: "Alumno",
      align: "center",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, i) => {
          let alumno = state.alumnosInscritos[dataIndex].alumno;
          return (
            <div
              style={{ height: "60px", width: "100%" }}
              className={
                i % 2 === 0
                  ? " d-flex align-items-center justify-content-center"
                  : "d-flex align-items-center justify-content-center"
              }
            >
              {alumno}
            </div>
          );
        },
      },
    },
    {
      name: "fechainicioperiodo",
      label: "Inicio periodo",
      align: "center",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, i) => {
          let fechainicioperiodo =
            state.alumnosInscritos[dataIndex].fechainicioperiodo;
          return (
            <div
              style={{ height: "60px", width: "100%" }}
              className={
                i % 2 === 0
                  ? "d-flex align-items-center justify-content-center"
                  : "d-flex align-items-center justify-content-center"
              }
            >
              {fechainicioperiodo}
            </div>
          );
        },
      },
    },
    {
      name: "fechafinperiodo",
      label: "Fin periodo",
      align: "center",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, i) => {
          let fechafinperiodo =
            state.alumnosInscritos[dataIndex].fechafinperiodo;
          return (
            <div
              style={{ height: "60px", width: "100%" }}
              className={
                i % 2 === 0
                  ? "d-flex align-items-center justify-content-center"
                  : "d-flex align-items-center justify-content-center"
              }
            >
              {fechafinperiodo}
            </div>
          );
        },
      },
    },
    {
      name: "acciones",
      label: "Acciones",

      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex, i) => {
          // let alumno = state.alumnosInscritos[dataIndex].talleres;

          return (
            <div
              style={{ height: "60px", width: "100%" }}
              className={
                i % 2 === 0
                  ? "d-flex align-items-center justify-content-center gap-1"
                  : "d-flex align-items-center justify-content-center gap-1"
              }
            >
              <Tooltip title="Ver Detalles">
                <div
                  style={{ height: 30, width: 30, zIndex: 0 }}
                  className="cta cta--primary cta--icon icon_btn"
                  onClick={() => {
                    openmodalDetalle(dataIndex);
                  }}
                >
                  <IconUI size={"20px"} color={"black"}>
                    <RemoveRedEyeIcon />
                  </IconUI>
                </div>
              </Tooltip>
            </div>
          );
        },
      },
    },
  ];

  const options = {
        filter: false, 
        sort: false,   
        search: true,
        print: false,
        download: false,
        viewColumns: false,
        selectableRows: "none",
        tableBodyHeight: "auto",
        responsive: "standard",
        serverSide: true, 
        count: state.count, 
        page: state.page,   
        rowsPerPage: state.rowsPerPage,
        rowsPerPageOptions: [50], 
        
       
        textLabels: {
            body: { noMatch: "Lo sentimos, no hay coincidencias", toolTip: "Ordenar" },
            pagination: { next: "Siguiente", previous: "Anterior", rowsPerPage: "Filas por página:", displayRows: "de" },
            toolbar: { search: "Buscar", viewColumns: "Ver columnas", filterTable: "Filtrar tabla" },
        },  
      
        customSearchRender: customSearchFn,

        onTableChange: handleTableChange 
    };

  

  const handleChangeAlumno = (e) => {
    setState({ ...state, alumnoSelect: e });
    setValidation({ ...validate, alumnoValidate: "gray" });
  };

  const handleChangeDisciplina = (selectedItems) => {
   const disciplinasSeleccionadas = selectedItems ? selectedItems.map(item => item.disciplina) : [];
  
  const todosTalleres = state.talleres.flatMap(item => item.talleres);

  
  const hoy = new Date().toISOString().split('T')[0];

  
  const talleresDisponibles = todosTalleres.filter(taller => {
    const tieneCupo = taller.disponibles > 0;
    const periodoActivo = taller.fechaincrpcioninicio <= hoy && taller.fechaincrpcionfin >= hoy;
    return tieneCupo && periodoActivo && taller.estatus === 1;
  });

  const talleresFiltrados = disciplinasSeleccionadas.length > 0
    ? talleresDisponibles.filter(taller => 
        disciplinasSeleccionadas.includes(taller.nombredisciplina))
    : talleresDisponibles;

 setState({
    ...state,
    disciplinasSeleccionadas: disciplinasSeleccionadas,
    TallerSelect: talleresFiltrados, 
  });
 
};

  useEffect(() => { }, [state.disciplinaSelect]);

 


  const handleChangeTallerSelect = (selectedOptions) => {
    setState({
      ...state,
      idTaller: selectedOptions ? selectedOptions.map(item => item.id) : [],
    });
    
    setValidation({ ...validate, tallerValidate: "gray" });
  };


  const handleChangeDescuento = (e) => {
    setState({ ...state, descuento: e.value });
  };

  const handleChangeTD = (e) => {
    setState({ ...state, tipo_descuento: e.value });
  };


  const api = async (page = 1) => {
  try {
    const [talleresRes, alumnosRes] = await Promise.all([
      services("GET", "usuarios/listarperiodostallers", null),
      services("POST", "usuarios/listarusuarios", { tipo: "Alumno" }),
      // services("GET", `usuarios/miscursos?page=${page}`, null),
    ]);

    await obtenerDatos(page, "");

    setState((prev) => ({
      ...prev,
      talleres: talleresRes.data || [], 
      alumnos: alumnosRes.data || [],
      loadingAlumnos: false,
      loadingTalleres: false,
      loading: false,
      
     
      open: false,
      openDetalle: false,
      fecha_inscripcion: "",
    }));

    

    

  } catch (error) {
    console.error("Error cargando datos iniciales:", error);
  
    setState((prev) => ({
      ...prev,
      loadingAlumnos: false,
      loadingTalleres: false,
      loading: false
    }));
  }
};



  const obtenerDatos = async (pagina, busqueda = "") => {
        setState(prev => ({ ...prev, loading: true }));
        try {
           
            const response = await services("GET", `usuarios/miscursos?page=${pagina}&query=${busqueda}`, null);
            
            const respuestaBackend = response.data; 

            setState(prev => ({
                ...prev,
                alumnosInscritos: respuestaBackend.data || [], 
                count: respuestaBackend.total, 
                page: respuestaBackend.current_page - 1, 
                rowsPerPage: respuestaBackend.per_page,
                searchText: busqueda,
                loading: false
            }));

        } catch (error) {
            console.error(error);
            setState(prev => ({ ...prev, loading: false }));
        }
    };

  



  
  
  const modalidadCarrito = async () => {
  setLoader(true);

  try {
    const idAlum = state.alumnoSelect?.id;
    const idTall = state.idTaller;
    const desAlum = state.descuento;
    const tipoAl = state.tipo_descuento;
    
    const body = {
      alumno: idAlum,
      talleres: idTall,
      descuento: desAlum,
      tipo: tipoAl
    };

    if (idAlum && tipoAl && idTall) {
      
      const { status, data } = await services("POST", "carrito", body);

     if (status === 200) {
        showNotification("success", "Inscripción exitosa", "", null, 4);

        if (typeof api === 'function') api();

        setState((prev) => ({
          ...prev,
          open: false,          
          openCaptura: false,  
          alumnoSelect: null, 
          idTaller: [], 
          descuento: null, 
          tipo_descuento: null, 
        })); 
      }

      if (status === 421) {
         if (typeof api === 'function') api();
         setState((prev) => ({
          ...prev,
          open: false,          
          openCaptura: false,  
          alumnoSelect: null, 
          idTaller: [], 
          descuento: null, 
          tipo_descuento: null, 
        })); 
        const erroresTalleres = data.errors?.talleres;
        if (erroresTalleres && Array.isArray(erroresTalleres)) {
          erroresTalleres.forEach((mensaje) => {
            showNotification("error", mensaje, null, 4);
          });
        }
      }

      if (status === 422) {
         if (typeof api === 'function') api();
         setState((prev) => ({
          ...prev,
          open: false,          
          openCaptura: false,  
          alumnoSelect: null, 
          idTaller: [], 
          descuento: null, 
          tipo_descuento: null, 
        })); 
        data.talleres?.forEach((item) => {
          item.errores?.forEach((mensaje) => {
            showNotification("error", mensaje, item.nombre_taller, null, 4);
          });
        });
      }

      if (status === 425) {
         if (typeof api === 'function') api();
         setState((prev) => ({
          ...prev,
          open: false,          
          openCaptura: false,  
          alumnoSelect: null, 
          idTaller: [], 
          descuento: null, 
          tipo_descuento: null, 
        })); 
        data.periodos?.forEach((item) => {
          if (item.error) {
            showNotification("error", item.error, null, 4);
          }
        });
      }

    } else {
      showNotification("error", "Todos los campos son requeridos", null, 4);
    }

  } catch (error) {
    console.error("Error en modalidadCarrito:", error);
    showNotification("error", "Ocurrió un error inesperado. Intente nuevamente.", null, 4);
    
  } finally {
    setLoader(false);
  }
};

  const handleClickInscribir = () => {
    modalidadCarrito();
  };
 
  
  const descuento = [
    { descripcion: "Descuento 0%", value: 0 },
    { descripcion: "Descuento 25%", value: 25 },
    { descripcion: "Descuento 50%", value: 50 },
    { descripcion: "Descuento 75%", value: 75 },
    { descripcion: "Descuento 100%", value: 100 },
  ];

  const optionsTD = [
    { value: "STASPE", label: "STASPE" },
    { value: "INAPAM", label: "INAPAM" },
    { value: "bajos_recursos", label: "Bajos Recursos" },
    { value: "Discapacidad", label: "Discapacidad" },
    { value: "Ordinario", label: "Ordinario" },
  ];

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      api(1);
    }

    return () => {
      isMounted = false;
    };
   // eslint-disable-next-line
  }, []);

  return (
    <>
      {loader && <LoaderComponent />}
      {state.loading ? (
        <div style={{ height: "calc(100vh - 80px)" }}>
          <span className="loader"></span>
        </div>
      ) : (
        <>
          {state.data ? (
            <div style={state.data.length > 3 ? {} : { height: "calc(100vh)" }}>
              <div className="container mb-5 ">
                <Grid sx={{ marginTop: 6 }} container spacing={2}>
                  <Grid align="center" item xs={12} sm={6} md={6}></Grid>
                  <Grid align="right" item xs={12} sm={6} md={6}>
                    <div
                      style={{ width: 300 }}
                      className="cta cta--guinda"
                      onClick={() => {
                        openmodal();
                      }}
                    >
                      <div className="me-2">
                        <IconUI size={"20px"} color={"white"}>
                          <AiOutlineUserAdd />
                        </IconUI>
                      </div>
                      Inscribir Nuevo Alumno
                    </div>
                  </Grid>
                </Grid>
              </div>
              
              <div style={{paddingBottom:50}}>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid className="container mt-5 mb-5">
                    <Grid item xs={8}>
                      <MUIDataTable
                        title={"Inscripciones"}
                          data={state.alumnosInscritos}
                          columns={columns}
                          options={options}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </div>
              

              <Modal
                open={state.open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={styleModal}>
                  <Grid item xs={12} sm={12} md={12}>
                    <h4>Inscribir alumno</h4>
                    <hr></hr>
                  </Grid>
                  <Grid
                    container
                    spacing={3}
                    sx={{ justifyContent: "center", alignItems: "center" }}
                  >
                    <Grid item xs={12} sm={12} md={12}>
                      <Select
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderColor: state.isFocused
                              ? "grey"
                              : validate.alumnoValidate,
                          }),
                        }}
                        getOptionValue={(options) => options.id}
                        getOptionLabel={(options) =>
                          `${options.nombre} ${options.apaterno} ${options.amaterno}`
                        }
                        className="Alumno"
                        placeholder={
                          <>
                            <SearchIcon />
                            Alumnos
                          </>
                        }
                        classNamePrefix="Seleccione Alumno"
                        isLoading={state.loadingAlumnos}
                        isClearable={true}
                        isSearchable={true}
                        name="Alumno"
                        options={state.alumnos}
                        noOptionsMessage={() => "Sin resultados"}
                        onChange={(item) => handleChangeAlumno(item)}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                      <Select
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderColor: state.isFocused
                              ? "grey"
                              : validate.disciplinaValidate,
                          }),
                        }}
                        getOptionValue={(options) => options.disciplina}
                        getOptionLabel={(options) => `${options.disciplina}`}
                        className="Taller"
                        placeholder="Disciplina"
                        classNamePrefix="Seleccione Taller"
                        isLoading={state.loadingTalleres}
                        isClearable={true}
                        isSearchable={true}
                        isMulti={true}
                        name="Disciplina"
                        options={state.talleres}
                        noOptionsMessage={() => "Sin resultados"}
                        onChange={(item) => handleChangeDisciplina(item)}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                      <Select
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderColor: state.isFocused
                              ? "grey"
                              : validate.tallerValidate,
                          }),
                        }}
                        getOptionValue={(options) => options.id}
                        getOptionLabel={(options) => `${options.nombretaller}`}
                        className="Taller"
                        placeholder="Talleres"
                        classNamePrefix="Seleccione Taller"
                        isLoading={state.loadingTalleres}
                        isClearable={true}
                        isSearchable={true}
                        isMulti={true}
                        name="Alumno"
                        options={state.TallerSelect}
                        noOptionsMessage={() => "Sin resultados"}
                        onChange={handleChangeTallerSelect}
                        value={state.TallerSelect.filter(taller => state.idTaller.includes(taller.id))}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                      <Select
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderColor: state.isFocused
                              ? "grey"
                              : validate.alumnoValidate,
                          }),
                        }}
                        getOptionValue={(options) => options.value}
                        getOptionLabel={(options) => `${options.descripcion}`}
                        className="descuento"
                        placeholder="Descuento"
                        classNamePrefix="Seleccione Descuento"
                        isClearable={true}
                        isSearchable={true}
                        name="descuento"
                        options={descuento}
                        noOptionsMessage={() => "Sin resultados"}
                        onChange={(item) => handleChangeDescuento(item)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <Select
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderColor: state.isFocused
                              ? "grey"
                              : validate.alumnoValidate,
                          }),
                        }}
                        getOptionValue={(options) => options.value}
                        getOptionLabel={(options) => `${options.label}`}
                        className="descuento"
                        placeholder="Tipo de Descuento"
                        classNamePrefix="Seleccione Tipo de Descuento"
                        isClearable={true}
                        isSearchable={true}
                        name="descuento"
                        options={optionsTD}
                        noOptionsMessage={() => "Sin resultados"}
                        onChange={(item) => handleChangeTD(item)}
                      />
                    </Grid>
                  </Grid>

                  <Grid
                    container
                    spacing={2}
                    sx={{ justifyContent: "center", alignItems: "center" }}
                  ></Grid>
                  <Grid
                    container
                    className="mt-5"
                    spacing={2}
                    sx={{
                      flexDirection: "column",
                      textAlign: "center",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {state.talleresOption?.length !== 0 && (
                      <>
                        Fechas de Inscripciones
                        {state.talleresOption.map((elem) => {
                          return (
                            <p>
                              {" "}
                              <strong>{elem.nombretaller}</strong> <br /> Fecha
                              Inicio:{elem.fechaincrpcioninicio} - Fecha Final{" "}
                              {elem.fechaincrpcionfin}
                            </p>
                          );
                        })}
                      </>
                    )}
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    sx={{
                      justifyContent: "center",
                      alignItems: "center",
                      paddingTop: "5%",
                    }}
                  >
                    <Grid item xs="auto">
                      <ColorButton
                        sx={{ mr: 2 }} // margen derecho
                        variant="outlined"
                        type="button"
                        endIcon={<CloseIcon />}
                        onClick={handleClose}
                      >
                        Cancelar
                      </ColorButton>



                      



                      <ColorButton
                        onClick={handleClickInscribir}
                        endIcon={<SaveIcon />}
                      >
                        INSCRIBIR
                      </ColorButton>
                    </Grid>
                  </Grid>
                </Box>
              </Modal>

              <Modal
                open={state.openDetalle}
                onClose={handleCloseDetalle}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={styleModal}>
                  <div className="mb-3">
                    {state.talleresAlumnosInscritos.length !== 0 ? (
                      <>
                        <h2>{state.alumnoActual}</h2>
                        <hr></hr>
                        {state.talleresAlumnosInscritos.map((item) => {
                          return (
                            <>
                              <Accordion>
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls="detalle"
                                  id="detalle"
                                  style={{
                                    backgroundColor: "#69164a",
                                    color: "white",
                                  }}
                                >
                                  <Typography>
                                    Taller: {item.nombretaller}
                                  </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <table className="table table-bordered table-hover table-checkable ">
                                    <tbody>
                                      <tr>
                                        <td className="text-left">
                                          <b>Fecha límite de pago</b>:
                                        </td>
                                        <td className="text-center break">
                                          <b>{item.fechavencimientotaller}</b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-left">
                                          <b>Status pago:</b>
                                        </td>
                                        <td className="text-center break">
                                          <b>{item.stastustaller}</b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-left">
                                          <b>Ver orden de pago</b>
                                        </td>
                                        <td className="text-center break">
                                          <b>{item.lineacaptura}</b> {/* aqqui va */}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-left">
                                          <b>Nivel:</b>
                                        </td>
                                        <td className="text-center break">
                                          <b>{item.nivel}</b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-left">
                                          <b>Descuento:</b>
                                        </td>
                                        <td className="text-center break">
                                          <b>${item.descuento} mxn</b>
                                        </td>
                                      </tr>
                                      {item.stastustaller === "pendiente" ? (
                                        <tr className="bg-rosaClaro">
                                         
                                        </tr>

                                        
                                      ) : (
                                        <></>
                                      )}
                                    </tbody>
                                  </table>

                                  <ColorButton
                                    onClick={() => {
                                      const newWindow = window.open(
                                        item.FORMATO,
                                        "_blank",
                                        "noopener,noreferrer"
                                      );
                                      if (newWindow) newWindow.opener = null;
                                    }}
                                    endIcon={<SaveIcon />}
                                  >
                                    Ver detalle Linea de captura
                                  </ColorButton>

             
                                </AccordionDetails>
                              </Accordion>
                            </>
                          );
                        })}
                      </>
                    ) : (
                      <>
                        <hr></hr>
                        <h3 className="text-center">
                          Este alumno no cuenta con talleres activos...
                        </h3>
                        <hr></hr>
                      </>
                    )}
                  </div>

                  <Grid container spacing={2} sx={{ paddingTop: "5%" }}>
                    <div className="d-flex w-100">
                      <div className="col"></div>
                      <ColorButton
                        variant="outlined"
                        type="button"
                        endIcon={<CloseIcon />}
                        onClick={handleCloseDetalle}
                      >
                        Cerrar
                      </ColorButton>
                    </div>
                  </Grid>
                </Box>
              </Modal>

              <Modal
                open={state.openCaptura}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <Grid>
                    <div className=" position-relative vh-100 d-flex flex-direction-column justify-content-center aling-items-center pt-3 pb-3">
                      <h4 className="position-absolute top-0 start-0 font-bold">
                        Orden de pago
                      </h4>
                      <iframe
                        src={GlobalState.formatoDetalle}
                        title="Orden de pago"
                        className="mt-4"
                        width="100%"
                        height="100%"
                      ></iframe>
                    </div>
                  </Grid>
                </Box>
              </Modal>
            </div>
          ) : (
            <div style={{ height: "calc(100vh - 80px)" }}>
              <span className="loader"></span>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Inscripciones;
